<template>
    <div class="pageContent">
        <!--<mu-appbar title="" class="top">
            <router-link slot="left" to="/home/index"><mu-icon value="keyboard_arrow_left" color="white"/></router-link>
            <mu-flat-button label="选择城市" class="demo-flat-button"/>
        </mu-appbar>-->
      <pageTitle title='选择城市'></pageTitle>

        <mu-paper class="search-paper" :zDepth="1">
          <mu-auto-complete hintText="输入城市名查询" :dataSource="nameDataSource" @change="handlechange" icon="search" :maxSearchResults="10" class="inputCity"/>
        </mu-paper>

        <mu-sub-header class="title">当前城市</mu-sub-header>
          <mu-raised-button label ="" class="labelDiv" @click="handleCitychange(LocationInfo)" >
            <mu-icon value="location_on"/>{{ LocationInfo.CityName }}
          </mu-raised-button>
          <div class="divDivider" />
          
          <mu-sub-header class="title">热门城市</mu-sub-header>
          <div class="hotTr" v-for="(item,key) in hotCity" @click="handleCitychange(item)">
            <div v-bind:class="[key==hotCity.length-1 ? 'hotTdLast': 'hotTd',]">
              {{item.CityName}}
            </div>
          </div>
          <div class="divDivider" />


          <mu-tabs :value="activeTab" @change="handleTabChange" class="kosmos-tabs">
            <mu-tab value="tabFirst" title="国内城市"/>
            <mu-tab value="tabSecond" title="海外城市"/>
          </mu-tabs>
          <div v-if="activeTab === 'tabFirst'">
            <mu-sub-header class="title">按字母排序</mu-sub-header>
            <div class="letterDiv">
              <div v-for="(item,key) in cityByLetter" v-bind:class="[key==cityByLetter.length-1 ? 'letterLabelLast': 'letterLabel',]" @click="goAnchor('#anchor-'+item.Letter)">
                {{item.Letter}}
              </div>
            </div>
            <div class="divDivider" />
            <div class="letterCity" v-for="item in cityByLetter">
                <mu-sub-header class="title" :id="'anchor-'+item.Letter">{{item.Letter}}</mu-sub-header>
                <div class="cityTr" v-for="(itemCity,key) in item.Citys" @click="handleCitychange(itemCity)">
                  <div v-bind:class="[key==item.Citys.length-1 ? 'cityTdLast': 'cityTd',]">
                    {{itemCity.CityName}}
                  </div>
                </div>
                 <div class="divDivider" />

            </div>
          </div>
          <div v-if="activeTab === 'tabSecond'">
            <div class="letterCity" v-for="item in overSeaCityByLetter">
              <div v-if="item.Citys.length>0">
                <mu-sub-header class="title" :id="'anchor-'+item.Letter">{{item.Letter}}</mu-sub-header>
                <div class="cityTr" v-for="(itemCity,key) in item.Citys" @click="handleCitychange(itemCity)">
                  <div v-bind:class="[key==item.Citys.length-1 ? 'cityTdLast': 'cityTd',]">
                    {{itemCity.CityName}}
                  </div>
                </div>
                 <div class="divDivider" />
              </div>
            </div>
          </div>         
  </div>
</template>

<style lang="less">
@import "../../assets/theme.less";
@import "../../assets/common.less";
.pageContent{
  .mu-appbar-title{
    text-align:center;
    margin-top:-10px;
  }
  .title{
    color:@primaryBlack;
    clear:both;
  }
  .labelDiv{
    margin-left:16px;
    margin-bottom:16px;
    box-shadow:none;
    border:1px solid #E5E5E5;
  }
  .divDivider{
    background-color:#F9F9F9;
    padding-bottom:10px;
    clear:both;
  }
  .hotTr{
    width:25%;
    text-align:center;
    float:left;
  }
  .hotTd{
    padding-top:5px;
    padding-bottom:5px;
    width:80%;
    margin-left:10%;
    border:1px solid @primaryBorderGrey;
    margin-bottom:5px;
  }
  .hotTdLast{
     padding-top:5px;
    padding-bottom:5px;
    width:80%;
    margin-left:10%;
    border:1px solid @primaryBorderGrey;
    margin-bottom:5px;
    margin-bottom:16px;
  }

  .tabs{
    width:92%;
    margin-left:auto;
    margin-right:auto;
  }
  .letterDiv{
    width:92%;
    margin-left:auto;
    margin-right:auto;
  }
  .letterLabel{
    width:10%;
    text-align:center;
    float:left;
  }
  .letterLabelLast{
    width:10%;
    text-align:center;
    float:left;
    margin-bottom:16px;
  }
  .cityTr{
    width:25%;
    text-align:center;
    float:left;
  }
  .cityTd{
    padding-top:5px;
    padding-bottom:5px;
    width:80%;
    margin-left:10%;
    border:1px solid @primaryBorderGrey;
    margin-bottom:5px;
  }
  .cityTdLast{
     padding-top:5px;
    padding-bottom:5px;
    width:80%;
    margin-left:10%;
    border:1px solid @primaryBorderGrey;
    margin-bottom:5px;
    margin-bottom:16px;
  }

  .inputCity{
    .mu-text-field{
      width:100%;
      margin-bottom:4px;
      margin-top:4px;
      .mu-text-field-content{
        .mu-text-field-hint{
          text-align:left;
        }
      }
    }
  }
}




</style>
<script>
import {BaiDuMap} from '../../components/BaiDuMap.js'
import Map from '../../components/map.js'
import api from '../../api'
import {mapMutations, mapGetters } from 'vuex'
window.onload = Map.load; 
export default {
  data () {
    return {
      nameDataSource: [],
      idDataSource:[],
      LocationInfo: {CityID:226,CityName:"定位中...",DALStatus:0,FullSpell:"shanghai",PY:"shanghai",ShortSpell:"sh"},
      hotCity:[],
      cityByLetter:[],
      activeTab: 'tabFirst',
      overSeaCityByLetter:[]
    }
  },
  created () {
    this.get()
  },
  methods: {
    get () {
      this.$http.post(api.getHotCity()).then((res) => {
      
        if(res.Result)
          this.hotCity = res.Data;
      })
      this.$http.post(api.getCityByLetter()).then((res) => {
        if(res.Result){
          this.cityByLetter = res.Data;
          this.dataSource=[];
          for(var i=0;i<res.Data.length;i++){
            for(var j=0;j<res.Data[i].Citys.length;j++){
      
              //this.nameDataSource.push(res.Data[i].Citys[j].CityName);
             // this.idDataSource.push(res.Data[i].Citys[j].CityID);
            }
          }
        }
      })

      this.$http.post(api.getOverSeaCityByLetter()).then((res) => {
        if(res.Result){
          this.overSeaCityByLetter=res.Data;
          for(var i=0;i<res.Data.length;i++){
            for(var j=0;j<res.Data[i].Citys.length;j++){
              if(this.nameDataSource.indexOf(res.Data[i].Citys[j].CityName)<0){
                //this.nameDataSource.push(res.Data[i].Citys[j].CityName);
                //this.idDataSource.push(res.Data[i].Citys[j].CityID);
              }
            }
          }
        }
      })
     
       this.$http.post(api. getCity()).then((res) => {
          if(res.Result){
               for(var i=0;i<res.Data.length;i++){                
                 this.nameDataSource.push(res.Data[i].FullName);
                 this.idDataSource.push(res.Data[i].CityId);
               }
          }
       })

    },
    handlechange (val) {
      var idIndex=this.nameDataSource.indexOf(val);
      var selectCityId=this.idDataSource[idIndex];
      //城市信息
      var cityInfo=this.g_city;
      cityInfo.id=selectCityId;
      cityInfo.name=val;
      this.setG_city(cityInfo);
      //城市名称
      this.setG_currentCityName(val);

      //搜索条件清空
      this.setG_searchKeyWord('');

      var searchParam=this.g_searchParam;
      searchParam.cityId=selectCityId;
      searchParam.PointType='';
      searchParam.PointText='';
      searchParam.hotelCode='';
      this.setG_searchParam(searchParam);



      // this.$router.push({ path: '/home/index'})
      this.goback();

    },
    handleCitychange(val){

      //城市信息
      var cityInfo=this.g_city;
      cityInfo.id=val.CityID;
      cityInfo.name=val.CityName;
      this.setG_city(cityInfo);
      //城市名称
      this.setG_currentCityName(val.CityName);
      //搜索条件
      var searchParam=this.g_searchParam;
      searchParam.cityId=val.CityID;
      searchParam.PointType='';
      searchParam.PointText='';
      searchParam.areaId='';
      searchParam.hotelCode='';
      this.setG_searchParam(searchParam);

      //区域清空
      this.setG_searchKeyWord('');

      //跳转
      // this.$router.push({ path: '/home/index'})
      this.goback();

    },
    handleTabChange(val){
      this.activeTab = val;
    },
    goAnchor(selector){
      var anchor = this.$el.querySelector(selector);
      document.body.scrollTop = anchor.offsetTop
    },
    //设置当前城市信息
    setLocationInfo(name){
      var params = new this.URLSearchParam();
      params.append('cityName', name)
        this.$http.post(api.getCityIDByCityName(),params.toParam()).then((res) => {
          if(res.Result){
            this.LocationInfo.CityName = name
            this.LocationInfo.CityID = res.Data
          }
          else{
          }
        })
    },
    locate(){
        //定位
        var map = new BMap.Map("mapA");
        var setLocationInfo = this.setLocationInfo
        var myFun = function(result){
            var cityName = result.name;
            setLocationInfo(cityName)
	      }
        var myCity = new BMap.LocalCity();
        myCity.get(myFun);
    },
    goback(){
      javascript:history.go(-1);
    },

    ...mapMutations([
      'setG_city',
      'setG_currentCityName',
      'setG_searchParam',
      'setG_searchKeyWord'
    ])
  },
  mounted () {
    if(typeof(BMap) != "undefined"){
        this.locate();
    }
    else{
        BaiDuMap().then( BMap => {
            // 创建Map实例
            this.locate();
        })
    }
  },
  computed: {
    ...mapGetters([
      'g_city',
      'g_currentCityName',
      'g_searchParam'
    ])
  }
}
</script>




// WEBPACK FOOTER //
// selectCity.vue?737a7de2